import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Menu } from 'antd';

import './index.scss';

import { version } from '../../../package.json'

import { APP_SIDER_MENU_TYPE, APP_SIDER_MENU } from '../../data/config/constants';
import { isModuleAccessible, log } from '../../data/config/utils';
import { BRAND_INFO } from '../../data/config/urls';

const SubMenu = Menu.SubMenu;

class AppSider extends React.PureComponent {

  render() {
    const { current_page, current_sider_module, permissions, navigateTo, sider_collapsed } = this.props;
    log('AppSIder rendered');
    return (
      <div className="ori-full-width ori-full-parent-height oriAppSiderContainer">
        <div className={classNames("ori-relative ori-tb-pad-10 ori-flex-column ori-flex-jc ori-b-mrgn-20 logoContainer", { "ori-lr-pad-5": sider_collapsed, "ori-l-pad-15": !sider_collapsed })}>
          <img
            src={BRAND_INFO.app_sider_logo}
            alt={`${BRAND_INFO.shortend_name} logo`}
            className="ori-animated ori-zoom-in ori-full-width"
          />
          {
            version &&
            <div
              className={
                classNames(
                  "ori-absolute ori-align-bottom-neg-8 ori-font-xxs ori-lr-pad-3 ori-bg-primary ori-font-white ori-font-bold ori-border-radius-3",
                  {
                    "ori-align-left-10": sider_collapsed,
                    "ori-align-left-15": !sider_collapsed
                  }
                )
              }
            >
              {version}
            </div>
          }
        </div>
        <Menu mode="inline" className="ori-full-width siderMenu">
          {
            APP_SIDER_MENU.map((sider_item) => {
              const is_module_accessible = isModuleAccessible(permissions, sider_item.route_path);
              if (is_module_accessible && sider_item.type && sider_item.type === APP_SIDER_MENU_TYPE.MENU_ITEM) {
                const active = sider_item.app_page === current_sider_module;
                return (
                  <Menu.Item key={sider_item.app_page} className={classNames("siderMenuItem", { "ori-animated ori-zoom-in": sider_collapsed })}>
                    <span className={classNames("menuIcon", { "activeMenu": sider_collapsed && active, "ori-font-primary ori-font-bold": !sider_collapsed && active })} onClick={() => { navigateTo(sider_item.route_path); }}>
                      <span className="anticon">
                        <sider_item.Icon size={20} />
                      </span>
                      <span className="ori-capitalize">{sider_item.app_page}</span>
                    </span>
                  </Menu.Item>
                );
              } else if (is_module_accessible && sider_item.type && sider_item.type === APP_SIDER_MENU_TYPE.PAGE_TAB) {
                const active = sider_item.app_page === current_sider_module;
                return (
                  <Menu.Item key={sider_item.app_page} className={classNames("siderMenuItem", { "ori-animated ori-zoom-in": sider_collapsed })}>
                    <span className={classNames("menuIcon", { "activeMenu": sider_collapsed && active, "ori-font-primary ori-font-bold": !sider_collapsed && active })} onClick={() => { navigateTo(sider_item.route_path); }}>
                      <span className="anticon">
                        <sider_item.Icon size={20} />
                      </span>
                      <span className="ori-capitalize">{sider_item.app_page}</span>
                    </span>
                  </Menu.Item>
                );
              } else if (is_module_accessible && sider_item.type && sider_item.type === APP_SIDER_MENU_TYPE.SUB_MENU) {
                const active = sider_item.app_page === current_sider_module;
                return (
                  <SubMenu key={sider_item.app_page} className="siderSubMenu"
                    title={
                      <span className={classNames("ori-pad-5", {
                        "activeMenu": sider_collapsed && active, "ori-font-primary ori-font-bold": !sider_collapsed && active
                      })} onClick={() => { if (sider_collapsed) { navigateTo(sider_item.route_path); } }}>
                        <span className="anticon">
                          <sider_item.Icon size={20} />
                        </span>
                        <span className="ori-capitalize">{sider_item.app_page}</span>
                      </span>
                    }>
                    {
                      sider_item.children && sider_item.children.map((item) => {
                        const is_child_accessible = isModuleAccessible(permissions, item.route_path, sider_item.route_path);
                        if (is_child_accessible) {
                          return (
                            <Menu.Item key={item.app_page} className={classNames({ "ant-menu-item-selected": current_page === item.app_page })}>
                              <div className="ori-capitalize" onClick={() => { navigateTo(item.route_path); }}>{item.app_page}</div>
                            </Menu.Item>
                          );
                        } else {
                          return null;
                        }
                      })
                    }
                  </SubMenu>
                );
              } else {
                return null;
              }
            })
          }
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    current_page: state.page_details.current_page,
    current_sider_module: state.page_details.current_sider_module,
    permissions: state.admin_details.user_info && state.admin_details.user_info.permissions ? state.admin_details.user_info.permissions : null
  };
};

AppSider.propTypes = {
  current_page: PropTypes.string,
  current_sider_module: PropTypes.string,
  permissions: PropTypes.object,
  navigateTo: PropTypes.func,
  sider_collapsed: PropTypes.bool,
};

export default connect(mapStateToProps)(AppSider);



// WEBPACK FOOTER //
// ./src/components/appsider/index.js